export const NUMBER = /[0-9]/;
export const UPPER_CASE = /[A-Z]/;
export const LOWER_CASE = /[a-z]/;
export const SPECIAL_CHARACTERS = /[$&+:;=@#|'<>"^*()%_`~\s-]/;
export const PUNCTUATIONS = /[.,?!]/;
